<template>
  <v-checkbox v-model="profile.currentlyLooking"
              :label="`I am currently looking for an opportunity`"
              @change="submit" :color="themes.candidate.light.input">
  </v-checkbox>
</template>

<script>
// Vue Component
export default {
  props: ['value'],
  data() {
    return {
      // Model (object sent to API)
      profile: {
        currentlyLooking: this.value
      }
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('candidate/profile/update', this.profile)
    }
  }
}
</script>
